import React from 'react';
import NumberInput from './NumberInput';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(React.memo(NumberInput));
